import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Select from "react-select";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { Table } from "react-bootstrap";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import {
  DeleteServiceCaller,
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import moment from "moment";
import DeleteModal from "../../../../components/DeletePopUpComponent";
import * as Yup from "yup";

const AssetAllocationEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Asset Allocation"));
  }, []);

  const intialFormData = {
    TXNDate: "",
    ContactID: "",
    lines: [
      {
        LineNo: 0,
        BatchNo: "",
        AssetID: "",
        Quantity: 0,
        QuantityAllocated: 0,
        ProjectID: null,
        Location: "",
        MRP: "",
        TXNID: "",
        CategoryID: null,
      },
    ],
  };

  const [formData, setFormData] = useState(intialFormData);
  const [assetNamesByCategory, setAssetNamesByCategory] = useState([]);

  const [errors, setErrors] = useState({});

  const [filterDate, setFilterDate] = useState("");

  const [loading, setLoading] = useState(false);
  const [filterSelectedEmp, setFilterSelectedEmp] = useState("");

  const [empOption, setEmpOption] = useState([]);

  const [categoryOption, setCategoryOption] = useState([]);
  const [assetOption, setAssetOption] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  const [assetAllocatedEntries, setAssetAllocatedEntries] = useState([]);

  const [displayAllocatedEntriesTable, setDisplayAllocatedEntriesTable] =
    useState(false);
  const [assetLocationOpt, setAssetLocationOpt] = useState([]);

  useEffect(() => {
    fetchGetAssetAllocationData();
  }, []);

  const fetchGetAssetAllocationData = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}asset-allocation`);
      if (response.status === 200) {
        const emplst = response?.data?.empList?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setEmpOption(emplst);

        const CategoryLst = response?.data?.assetCategory?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setCategoryOption(CategoryLst);
        const assetLst = response?.data?.assetList?.map((ele) => ({
          value: ele?.AssetID,
          label: ele?.Name,
        }));
        setAssetOption(assetLst);

        const locationOpt = Object.entries(response?.data?.locations || {}).map(([key, value]) => ({
          value: key,
          label: value,
        }));
        setAssetLocationOpt(locationOpt);
        setLoading(false);
        setPageLoading(false);
      } else {
        console.error(
          "Failed to fetch Asset Allocation. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Asset Allocation:", error);
    }
  };

  useEffect(() => {
    fetchAssetAllocationDataShow(id);
  }, [id]);

  const fetchAssetAllocationDataShow = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}asset-allocation/${id}`
      );

      if (response.status === 200) {
        const cleanedData = response?.data?.data;

        setFilterSelectedEmp(cleanedData?.assets?.ContactID);
        setFilterDate(cleanedData?.assets?.TXNDate);
        const formEditData = {
          TXNDate: moment(cleanedData?.assets?.TXNDate).format("DD-MMM-YYYY"),
          ContactID: cleanedData?.assets?.ID,
          lines: cleanedData?.assetsLines?.map((ele, index) => ({
            LineNo: ele?.LineNo,
            BatchNo: ele?.BatchNo,
            AssetID: ele?.AssetID,
            canBeDelete: 1,
            CategoryID: ele?.CategoryID,
            ProjectID: ele?.ProjectID ||null,
            Location: ele?.Location,
            TXNID: ele?.TXNID,
            Quantity: ele?.Quantity,
            QuantityAllocated: ele?.QuantityAllocated,
            MRP: ele?.MRP,
          })),
        };
        setFormData(formEditData);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Asset Allocation. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Asset Allocation:", error);
    }
  };

  useEffect(() => {
    if (filterSelectedEmp != "") {
      fetchGetEmpTableDetails(filterSelectedEmp);
    }
  }, [filterSelectedEmp]);

  const [allocatedProjectOption, setAllocatedProjectOption] = useState([]);
  const fetchGetEmpTableDetails = async (id) => {
    try {
      const queryParams = new URLSearchParams({
        EmployeeName: id,
        AllocationDate: "",
      });
      const response = await GetServiceCaller(
        `${API_URL}support/procurement/asset-allocation-details?${queryParams.toString()}`
      );
      if (response.status === 200) {
        const cleanedData = response?.data?.data;

        setDisplayAllocatedEntriesTable(true);

        setAssetAllocatedEntries(cleanedData);

        const projectList = response?.data?.allocatedProject?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setAllocatedProjectOption(projectList);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Vendor Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Vendor Master:", error);
    }
  };

  const handleAddAssetLine = () => {
    const currentRow = formData.lines[formData.lines.length - 1];

    if (currentRow && currentRow.CategoryID === "") {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    // Find the maximum LineNo and increment by 1
    const existingLineNos = formData.lines.map((line) => line.LineNo);
    const newLineNo =
      existingLineNos.length > 0 ? Math.max(...existingLineNos) + 1 : 1;

    setFormData((prevState) => ({
      ...prevState,
      lines: [
        ...prevState.lines,
        {
          LineNo: newLineNo,
          BatchNo: "",
          AssetID: "",
          canBeDelete:0,
          Quantity: 1,
          QuantityAllocated: 0,
          MRP: "",
          CategoryID: "",
          ProjectID:null,
          Location: ""
        },
      ],
    }));
  };

  const handleFilterSelect = async (selectedOption, name) => {

    // Update formData with the selected value for the specified field (name)
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.value };

      // Update filterSelectedEmp
      setFilterSelectedEmp(selectedOption.value);

      // Trigger validation for the specific field after updating
      validateField(name, updatedData);

      return updatedData;
    });
  };

  const schema = Yup.object().shape({
    ContactID: Yup.number()
      .typeError("Allocated To is required")
      .required("Allocated To is required")
      .nullable(), // Allows the field to be null
    lines: Yup.array().of(
      Yup.object().shape({
        AssetID: Yup.number()
          .typeError("Asset To is required")
          .required("Asset To is required"),
        CategoryID: Yup.number()
          .typeError("Category To is required")
          .required("Category To is required"),
        ProjectID: Yup.string()
          // .typeError("Project is required")
          // .required("Project is required")
          .nullable(),
      })
    ),
  });

  const validateField = async (fieldName, updatedData) => {
    try {
      // Validate the specific field using Yup schema
      await schema.validateAt(fieldName, updatedData);

      // Clear the error for the validated field if successful
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "",
      }));
    } catch (err) {
      if (err.path === fieldName) {
        // Update the error for the specific field if validation fails
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));

        // Optionally show a toast error for specific fields
        if (fieldName.startsWith("brandsLine")) {
          toast.error(err.message, { position: "top-right" });
        }
      } else {
        console.error("Unexpected validation error structure:", err);
      }
    }
  };
  useEffect(() => {
    formData?.lines?.forEach((line, index) => {
      if (line?.CategoryID) {
        fetchAssetData(line.CategoryID, index);
      }
    });
  }, [formData?.lines]);

  const handleSelectChange = async (selectedOption, name, index) => {
    const updatedLines = [...formData.lines];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: selectedOption.value,
    };

    const updatedFormData = { ...formData, lines: updatedLines };
    setFormData(updatedFormData);

    // Validate the specific field in the 'lines' array
    await validateField(`lines[${index}].${name}`, updatedFormData);
    if (name === "CategoryID") {
      fetchAssetData(selectedOption.value, index);
    }
  };

  const fetchAssetData = async (categoryId, index) => {
    try {
      const response = await GetServiceCaller(`${API_URL}support/procurement/get-asset-name?assetCategory=${categoryId}`);
      // You can update additional data in formData here if needed
      const assetData = response?.data?.data;
      const asset = assetData?.map((item) => ({
        value: item.ID,
        label: item.Name,
      }));
      setAssetNamesByCategory(asset);
    } catch (error) {
      console.error("Error fetching data for category:", error);
    }
  };

  const handleDateChange = (e) => {
    setFilterDate(e.target.value);

    setFormData({ ...formData, TXNDate: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Construct payload
      const payload = {
        TXNDate: formData?.TXNDate,
        ContactID: filterSelectedEmp,
        lines: formData?.lines?.map((ele) => ({
          LineNo: ele?.LineNo,
          BatchNo: ele?.BatchNo,
          AssetID: ele?.AssetID,
          Quantity: ele?.Quantity,
          ProjectID: ele?.ProjectID,
          QuantityAllocated: ele?.QuantityAllocated,
          MRP: ele?.MRP,
          CategoryID: ele?.CategoryID,
          Location: ele?.Location
        })),
      };

      setFormData(payload);

      // Call the API

      await schema.validate(payload, { abortEarly: false });
      setErrors({});
      // Call the API using POST
      const response = await PostServiceCaller(
        `${API_URL}asset-allocation/${formData.ContactID}`,
        payload,
        "put"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
        // Redirect after a successful submission
        setTimeout(() => {
          navigate("/asset-allocation");
        }, 2000);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        console.error("Validation Error:", error);
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      } else {
        console.error("Unexpected Error:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchGetSerioNoApi = async (assetID, index) => {
    setLoading(true); // Set loading to true before the API call
    try {
      const response = await GetServiceCaller(
        `${API_URL}support-desk/reports/get-serial-no?AssetID=${assetID}`
      );

      if (response?.status === 200) {
        const serialNo = response?.data?.data?.[0]?.BatchNo;

        const price = response?.data?.data?.[0]?.MRP;
        // Update the specific index in 'lines'
        setFormData((prevData) => ({
          ...prevData,
          lines: prevData?.lines?.map(
            (line, idx) =>
              idx === index
                ? { ...line, BatchNo: serialNo, MRP: price } // Update the specific line
                : line // Keep other lines unchanged
          ),
        }));
      } else {
        console.error(
          `Failed to fetch serial numbers. Status: ${response?.status}`
        );
      }
    } catch (error) {
      console.error("Error fetching serial numbers:", error);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const handleDelete = (item) => {
    setSelectedDeleteItem(item);
    setShowDeleteModal(true);
  };
  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);
  };

  const handleModalDelete = () => {
    if (selectedDeleteItem) {
      {
        handleDeleteLine(selectedDeleteItem.LineNo, selectedDeleteItem.TXNID);
      }
      setShowDeleteModal(false);
      setSelectedDeleteItem(null);
    }
  };

  const handleDeleteLine = async (LineNo, TXNID) => {

    if (TXNID) {
      // Checks if PocID is truthy (not null, undefined, or empty)
      try {
        const response = await DeleteServiceCaller(
          `${API_URL}asset-allocation/${TXNID + "_" + LineNo}`,
          {},
          "delete"
        );
        if (response?.status === 200) {
          toast.success("Data Deleted successfully");
          setFormData((prevData) => ({
            ...prevData,
            lines: prevData.lines.filter((ele) => ele.LineNo !== LineNo),
          }));
        }
      } catch (error) {
        console.error("There was an error deleting the Row!", error);
      }
    }
  };


  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="Container">
          <form
            id="formOne"
            className="rounded mt-2 bg-white"
            onSubmit={handleSubmit}
          >
            <div class="card-body  mx-2">
              <div className="row">
                <div className="col-md-3">
                  <label className="form-label">
                    Allocation Date<span className="text-danger">*</span>
                  </label>
                  <CustomDatePicker
                    handleChange={(e) => handleDateChange(e)}
                    name="TXNDate"
                    id="TXNDate"
                    className="form-control"
                    value={formData?.TXNDate}
                    placeholderText="DD-MM-YYYY"
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">
                    Allocated To<span className="text-danger">*</span>
                  </label>
                  <Select
                    name="ContactID"
                    onChange={(selectedOption, action) =>
                      handleFilterSelect(selectedOption, action.name)
                    }
                    className={` ${errors.ContactID ? "is-invalid" : ""}`}
                    placeholder="Allocation To"
                    value={empOption?.find(
                      (o) => o?.value === filterSelectedEmp
                    )}
                    options={[
                      { value: null, label: "Select" },
                      ...empOption,
                    ]}
                  />
                  {errors.ContactID && (
                    <div className="invalid-feedback">
                      {errors.ContactID}
                    </div>
                  )}
                </div>
              </div>

              {/** Static Table Data */}
              {displayAllocatedEntriesTable != false ? (
                <div className="row mt-3">
                  <h5>
                    {assetAllocatedEntries.length || 0} Asset Allocated
                    Entries
                  </h5>
                  <div>
                    <Table bordered striped>
                      <thead id="thcolor" className="text-center">
                        <tr>
                          <th>Sr. No.</th>
                          <th>Category</th>
                          <th>Make</th>
                          <th>Asset</th>
                          <th>Serial No.</th>
                          <th>Project</th>
                          <th>Location</th>
                          <th>Allocated Date</th>
                          <th>Allocated By</th>
                          <th>Status</th>
                          <th>Asset value</th>
                        </tr>
                      </thead>
                      <tbody>
                        {assetAllocatedEntries?.map((ele, index) => (
                          <tr>
                            <td className="text-center">{index + 1}</td>
                            <td>{ele?.CategoryName}</td>
                            <td>{ele?.Brand}</td>
                            <td>{ele?.AssetName}</td>
                            <td>{ele?.BatchNo}</td>
                            <td>{ele?.Project}</td>
                            <td>{ele?.Location}</td>
                            <td className="text-center">
                              {moment(ele?.TXNDate).format("DD-MMM-YYYY")}
                            </td>
                            <td>{ele?.AllocatedFromName}</td>
                            <td>{ele?.Status}</td>
                            <td>{ele?.MRP}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              ) : null}

              {/** Static Table Data */}

              {/** Add Row Data */}

              <div className="row">
                <div className="table-responsive brand-details rounded mt-2">
                  <button
                    type="button"
                    onClick={handleAddAssetLine}
                    className="custom-btn-sm mb-2 pull-right"
                  >
                    <i class="fa fa-plus"></i>&nbsp;Add
                  </button>
                  <Table
                    style={{ background: "#ECECEC !important" }}
                    // id="poctable_head"
                    className="table table-bordered"
                  >
                    <thead
                      id="thcolor"
                      className="text-center align-middle  "
                    >
                      <tr>
                        <th>Sr. No.</th>
                        <th>
                          Category<span className="text-danger">*</span>
                        </th>
                        <th>
                          Project
                        </th>
                        <th>
                          Location<span className="text-danger">*</span>
                        </th>
                        <th>
                          Asset<span className="text-danger">*</span>
                        </th>
                        <th>Serial No.</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {formData?.lines?.map((ele, index) => (
                        <tr>
                          <td className="text-center align-middle">
                            {index + 1}
                          </td>
                          <td>
                            <Select
                              name="CategoryID"
                              onChange={(selectedOption, action) =>
                                handleSelectChange(
                                  selectedOption,
                                  action.name,
                                  index
                                )
                              }
                              placeholder="Category"
                              className={` ${errors?.[`lines[${index}].CategoryID`]
                                ? "is-invalid"
                                : ""
                                }`}
                              value={categoryOption?.find(
                                (o) => o.value === ele?.CategoryID
                              )}
                              menuPlacement="bottom"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 1050,
                                }),
                              }}
                              options={[
                                { value: null, label: "Select" },
                                ...categoryOption,
                              ]}
                            />
                            {errors?.[`lines[${index}].CategoryID`] && ( // Accessing errors for the specific line
                              <div className="invalid-feedback text-center">
                                {errors?.[`lines[${index}].CategoryID`]}{" "}
                                {/* Displaying the error message */}
                              </div>
                            )}
                          </td>
                          <td>
                            <Select
                              name="ProjectID"
                              // onChange={(selectedOption, action) => (
                              //     handleSelectChange(selectedOption, action.name, index), fetchGetSerioNoApi(selectedOption.value, index))
                              // }
                              onChange={(selectedOption, action) =>
                                handleSelectChange(
                                  selectedOption,
                                  action.name,
                                  index
                                )
                              }
                              placeholder="Project"
                              className={` ${errors?.[`lines[${index}].ProjectID`]
                                ? "is-invalid"
                                : ""
                                }`}
                              value={allocatedProjectOption?.find(
                                (o) => o.value === ele?.ProjectID
                              )}
                              menuPlacement="bottom"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 1050,
                                }),
                              }}
                              options={[
                                { value: null, label: "Select" },
                                ...allocatedProjectOption,
                              ]}
                            />
                            {errors?.[`lines[${index}].ProjectID`] && ( // Accessing errors for the specific line
                              <div className="invalid-feedback text-center">
                                {errors?.[`lines[${index}].ProjectID`]}{" "}
                                {/* Displaying the error message */}
                              </div>
                            )}
                          </td>
                          <td>
                            <Select
                              name="Location"
                              onChange={(selectedOption, action) =>
                                handleSelectChange(
                                  selectedOption,
                                  action.name,
                                  index
                                )
                              }
                              placeholder="Location"

                              value={assetLocationOpt?.find(
                                (o) => o.value === ele?.Location
                              )}
                              menuPlacement="bottom"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 1050,
                                }),
                              }}
                              options={[
                                { value: null, label: "Select" },
                                ...assetLocationOpt,
                              ]}
                            />
                          </td>
                          <td>

                            <Select
                              name="AssetID"
                              onChange={(selectedOption, action) => (
                                handleSelectChange(selectedOption, action.name, index),
                                fetchGetSerioNoApi(selectedOption.value, index)
                              )}
                              isDisabled={ele?.TXNID ? true : false}
                              placeholder="Asset"
                              className={` ${errors?.[`lines[${index}].AssetID`] ? "is-invalid" : ""}`}
                              value={assetNamesByCategory?.find((o) => o.value === ele?.AssetID)}
                              menuPlacement="bottom"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 1050,
                                }),
                              }}
                              options={assetNamesByCategory}
                            />

                            {errors?.[`lines[${index}].AssetID`] && (
                              <div className="invalid-feedback text-center">
                                {errors?.[`lines[${index}].AssetID`]}
                              </div>
                            )}

                          </td>

                          <td>
                            <input
                              className="form-control"
                              value={ele?.BatchNo}
                              disabled
                            />
                          </td>
                          <td>
                            <div
                              className="text-center d-flex item-align-center justify-content-center"
                              type="button"
                            // onClick={() => openDeleteModal('BrandLine', { index, ID: ele.ID })}
                            >
                              {/* {formData.lines.length > 1 && ( */}

                              <div
                                className="me-2 pt-1"
                                onClick={() => navigate(`/asset-return`)}
                              >
                                <i class="bi bi-arrow-right-circle"></i>
                              </div>
                              <div
                                className={`me-2 ${ele?.canBeDelete != 0
                                  ? "disabled-icon"
                                  : ""
                                  }`}
                                onClick={() => {
                                  if (ele?.canBeDelete !== 0)
                                    handleDelete(ele);
                                }}
                              >
                                <i
                                  className={`${ele?.canBeDelete !== 0 ? "disabled-icon bi bi-trash" : "bi bi-trash"}`}
                                  style={{ fontSize: "1.2rem" }}
                                ></i>
                              </div>
                              {/* )} */}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>

              {/** */}
              <div className="row">
                <div className="d-flex justify-content-end">
                  <div className="d-flex">
                    <div>
                      <button
                        type="button"
                        className="cancel-btn me-2"
                        onClick={() => navigate(`/asset-allocation`)}
                      >
                        Cancel
                      </button>
                    </div>
                    <div>
                      <button
                        disabled={loading ? true : false}
                        type="submit"
                        className="custom-btn"
                      >
                        {loading ? (
                          <FaSpinner class="sm-spinner" />
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          {/** Delete PopUP  */}

          <DeleteModal
            show={showDeleteModal}
            onClose={handleDeleteClose}
            onConfirm={handleModalDelete}
            message="Are you sure you want to delete this item?"
          />
        </div>
      </>
    );
  }
};

export default AssetAllocationEdit;
